
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#f25022","d":"M1 1h9v9H1z"}}),_c('path',{attrs:{"fill":"#00a4ef","d":"M1 11h9v9H1z"}}),_c('path',{attrs:{"fill":"#7fba00","d":"M11 1h9v9h-9z"}}),_c('path',{attrs:{"fill":"#ffb900","d":"M11 11h9v9h-9z"}})])
          )
        }
      }
    